import type { PublishedUnitSummary } from '@/lib/types/publicProperty';
import type { RentFrequencyType } from '@/lib/types/property';
import { calculateMonthlyRent } from '@/lib/utils/rentCalculations';

const ANNUAL_RATE_THRESHOLD = 10;

export function resolvePublicRentFrequency(unit: PublishedUnitSummary): RentFrequencyType {
  if (unit.rentFrequency !== 'monthly') {
    return unit.rentFrequency;
  }

  const highestRate = Math.max(unit.netRentPerSF, unit.additionalRentPerSF ?? 0);
  // Public listings typically store annual $/SF rates, even when frequency defaults to monthly.
  if (highestRate >= ANNUAL_RATE_THRESHOLD) {
    return 'annually';
  }

  return unit.rentFrequency;
}

export function calculatePublicMonthlyRent(unit: PublishedUnitSummary): number | null {
  return calculateMonthlyRent({
    netRentPerSf: unit.netRentPerSF,
    additionalRentPerSf: unit.additionalRentPerSF,
    unitSqFt: unit.areaSF,
    rentFrequency: resolvePublicRentFrequency(unit),
  });
}
